import {Component, computed, EventEmitter, inject, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SvgIconComponent} from '@/app/features/reportes/components/icon-cerrarFiltros/svg-icon.component';
import {
  FinalAssessmentsBreakdownComponent
} from '@/app/features/reportes/components/final-report/final-assessments-breakdown.component';
import {
  CategoryScoresBreakdownComponent
} from '@/app/features/reportes/components/final-report/category-scores-breakdown.component';
import {
  DomainScoresBreakdownComponent
} from '@/app/features/reportes/components/final-report/domain-scores-breakdown.component';
import {Scenario} from '@/app/features/reportes/components/report-controls/report-controls.component';
import {ThemeService} from "@/app/core/services/theme/theme.service";

@Component({
  selector: 'app-report-scenario',
  standalone: true,
  imports: [
    CommonModule,
    SvgIconComponent,
    FinalAssessmentsBreakdownComponent,
    CategoryScoresBreakdownComponent,
    DomainScoresBreakdownComponent,
  ],
  templateUrl: './report-scenario.component.html',
  styleUrls: ['./report-scenario.component.scss'],
})
export class ReportScenarioComponent {
  @Input() guideId: 'guia-i' | 'guia-ii' | 'guia-iii' = 'guia-i';
  @Input() campaignId: string | null = null;
  @Input() scenarios: Scenario[] = [];
  @Output() removeScenario = new EventEmitter<string>();

  protected reportContent = computed(() => this.themeContent()?.reports);
  protected scenarioContent = computed(() => this.reportContent()?.reportScenearioComponent);
  private themeService = inject(ThemeService);
  protected themeContent = this.themeService.themeContent;
}
